import CoreScroll from '../../mixins/core-scroll'
import CoreResize from '../../mixins/core-resize'


export default
{
    name: 'app-fadein',

    mixins:
    [
        CoreScroll,
        CoreResize
    ],

    props:
    {
        delay: { type: Number, default: 0 },
        move: { type: Number, default: 0 }
    },

    data()
    {
        return {
            isVisible: false
        }
    },

    created()
    {
        this._isVisible = false
        this._y = 0
    },

    mounted()
    {
        this.onResized()
    },

    destroyed()
    {
        clearTimeout(this._visibilityTo)
    },

    methods:
    {
        onResized()
        {
            this._y = this.$root.getScrollY()

            this._updateBox()
            this._updateTransform()            
        },

        onScroll(y)
        {
            this._y = y
            this._updateTransform()
        },

        _updateBox()
        {
            const main = document.body.querySelector('.js-container')
            const top = this.$el.getBoundingClientRect().top - main.getBoundingClientRect().top

            this._posY = top /* + this.$el.offsetHeight * 0.5*/ - this.move
        },

        _updateTransform()
        {
            if (!this._isVisible && this._y + this.resize.height > this._posY)
            {
                this._isVisible = true

                this._visibilityTo = setTimeout(() =>
                {
                    this.isVisible = true
                }, this.delay)
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/scripts/components/app-fadein/script.js